__turbopack_context__.v({
  "item": "ItineraryTagList-module__ETeeiW__item",
  "list": "ItineraryTagList-module__ETeeiW__list",
});
